import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  getStrings,
  getIframeUrl,
  checkFXEligibility,
  inquireGCIframeResults,
  sendLeadOrSms,
} from "./AppApi";
import { API_RESULT } from "src/utils/enums";
import { appState } from "./AppSlice";
import {
  GeneralErrorResponse,
  CheckFxEligibilityResponse,
  ResponseError,
  ErrorResponse,
  InquiryGCIframeResultsError,
} from "src/utils/types";
import { parseResponseError } from "src/utils/utils";
export const appExtraReducers = (
  builder: ActionReducerMapBuilder<appState>
) => {
  builder
    .addCase(getStrings.pending, (state) => {
      state.labelsResStatus = API_RESULT.LOADING;
    })
    .addCase(getStrings.fulfilled, (state, action) => {
      if (action.payload) {
        state.strings = action.payload.responseData.strings;
      }
      state.labelsResStatus = API_RESULT.SUCCEEDED;
    })
    .addCase(getStrings.rejected, (state) => {
      state.labelsResStatus = API_RESULT.FAILED;
    })
    .addCase(getIframeUrl.pending, (state) => {
      state.iframeResStatus = API_RESULT.LOADING;
    })
    .addCase(getIframeUrl.fulfilled, (state, action) => {
      state.iframeResStatus = API_RESULT.SUCCEEDED;
      if (action.payload?.url) {
        state.iframeUrl = action.payload.url;
        try {
          const url = new URL(action.payload.url);
          const txId = url.searchParams.get("txId");
          if (txId) {
            state.txId = txId;
          }
        } catch (e) {
          console.error("Failed to parse iframe URL:", e);
        }
      }
    })
    .addCase(getIframeUrl.rejected, (state) => {
      state.iframeResStatus = API_RESULT.FAILED;
    })
    .addCase(checkFXEligibility.pending, (state) => {
      state.fXEligibilityResStatus = API_RESULT.LOADING;
    })
    .addCase(checkFXEligibility.fulfilled, (state, action) => {
      state.fXEligibilityResStatus = API_RESULT.SUCCEEDED;
      state.fXEligibilityData = action.payload?.responseData ?? null;
      state.fXEligibilityResponseStatus = action.payload?.responseStatus ?? "";
      state.personalId = action.payload?.responseData?.personalId ?? "";
      state.sessionId = action.payload?.responseData?.sessionId ?? "";
    })
    .addCase(checkFXEligibility.rejected, (state, action) => {
      state.fXEligibilityResStatus = API_RESULT.FAILED;
      // state.fXEligibilityData = action.error.message as unknown as ResponseFxData;
      state.fXEligibilityErrorData = parseResponseError(
        action.error,
        {} as GeneralErrorResponse
      );
    
    })

    .addCase(inquireGCIframeResults.pending, (state) => {
      state.inquiryGCIframeResultsResStatus = API_RESULT.LOADING;
    })
    .addCase(inquireGCIframeResults.fulfilled, (state, action) => {
      state.inquiryGCIframeResultsResStatus = API_RESULT.SUCCEEDED;
      state.inquiryGCIframeResultsRes = action.payload;
    })
    .addCase(inquireGCIframeResults.rejected, (state, action) => {
      state.inquiryGCIframeResultsResStatus = API_RESULT.FAILED;
      state.inquiryGCIframeResultsError = parseResponseError(
        action.error,
        {} as InquiryGCIframeResultsError
      );
    })
    .addCase(sendLeadOrSms.pending, (state) => {
      state.sendLeadOrSmsResStatus = API_RESULT.LOADING;
    })
    .addCase(sendLeadOrSms.fulfilled, (state, action) => {
      state.sendLeadOrSmsResStatus = API_RESULT.SUCCEEDED;
      state.sendLeadOrSmsRes = action.payload;
    })
    .addCase(sendLeadOrSms.rejected, (state) => {
      state.sendLeadOrSmsResStatus = API_RESULT.FAILED;
    });
};
